import * as React from 'react';
import { Input, InputAdornment, TInputSize } from '@cian/ui-kit';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './RegionSuggestMobile.css';
import { IRegion } from '../../../../types/requestForm';
import { GeoSuggestModal } from '../GeoSuggestModal';

export interface IRegionSuggestMobileProps {
  disabled?: boolean;
  loading?: boolean;
  name?: string;
  onInputChange(text: string): void;
  onSelect(region: IRegion): void;
  placeholder?: string;
  region?: IRegion | null;
  size?: TInputSize;
  suggests: IRegion[];
  value: string;
  invalid?: boolean;
}

export const RegionSuggestMobile: React.FC<IRegionSuggestMobileProps> = ({
  disabled,
  loading,
  onInputChange,
  onSelect,
  region,
  suggests,
  value,
  ...inputProps
}) => {
  const [isSuggestOpen, setSuggestOpen] = React.useState(false);

  const displayValue = region?.label || '';

  const handleClick = React.useCallback(() => {
    setSuggestOpen(true);
  }, []);

  const closeSuggest = React.useCallback(() => {
    setSuggestOpen(false);
  }, []);

  return (
    <>
      <div className={styles['container']} onClick={disabled ? undefined : handleClick} tabIndex={0} role="button">
        <div className={styles['input']} data-testid="RegionSuggestMobile">
          <Input
            {...inputProps}
            aria-label={displayValue}
            disabled={disabled}
            value={displayValue}
            rightAdornment={
              <InputAdornment>
                <IconActionChevronDownSmall16 color="icon-main-default" />
              </InputAdornment>
            }
            role="presentation"
            tabIndex={-1}
          />
        </div>
      </div>
      <GeoSuggestModal
        loading={loading}
        onClose={closeSuggest}
        onInputChange={onInputChange}
        onSelect={onSelect}
        open={isSuggestOpen}
        suggests={suggests}
        value={value}
      />
    </>
  );
};
